class DatabaseService {
  constructor() {
    this.isConnected = false;
    this.collections = new Map();
  }

  async connect() {
    try {
      // Mock database connection
      this.isConnected = true;
      console.log('Database connected');
      return { success: true };
    } catch (error) {
      console.error('Database connection failed:', error);
      return { success: false, error: error.message };
    }
  }

  async disconnect() {
    this.isConnected = false;
    this.collections.clear();
    console.log('Database disconnected');
  }

  async create(collection, data) {
    if (!this.isConnected) {
      throw new Error('Database not connected');
    }

    const id = Date.now().toString();
    const record = { ...data, id, createdAt: new Date() };
    
    if (!this.collections.has(collection)) {
      this.collections.set(collection, new Map());
    }
    
    this.collections.get(collection).set(id, record);
    return record;
  }

  async read(collection, id = null) {
    if (!this.isConnected) {
      throw new Error('Database not connected');
    }

    const collectionData = this.collections.get(collection);
    if (!collectionData) {
      return id ? null : [];
    }

    if (id) {
      return collectionData.get(id) || null;
    }

    return Array.from(collectionData.values());
  }

  async update(collection, id, updates) {
    if (!this.isConnected) {
      throw new Error('Database not connected');
    }

    const collectionData = this.collections.get(collection);
    if (!collectionData || !collectionData.has(id)) {
      throw new Error('Record not found');
    }

    const existing = collectionData.get(id);
    const updated = { ...existing, ...updates, updatedAt: new Date() };
    collectionData.set(id, updated);
    
    return updated;
  }

  async delete(collection, id) {
    if (!this.isConnected) {
      throw new Error('Database not connected');
    }

    const collectionData = this.collections.get(collection);
    if (!collectionData) {
      return false;
    }

    return collectionData.delete(id);
  }

  async query(collection, filter = {}) {
    const records = await this.read(collection);
    
    return records.filter(record => {
      return Object.entries(filter).every(([key, value]) => {
        return record[key] === value;
      });
    });
  }
}

const databaseService = new DatabaseService();
export default databaseService;